var _path, _g, _path2, _g2, _rect, _rect2, _rect3, _g3, _path3, _path4, _path5, _path6, _path7, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 246,
    viewBox: "0 0 431 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62180_28226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 152,
    width: 175,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7377 153.418C93.4353 151.902 100.438 152.517 106.77 155.178C112.727 157.681 117.811 161.877 121.4 167.234C124.895 165.766 128.744 165.319 132.497 165.961C136.656 166.672 140.484 168.684 143.431 171.707C146.378 174.73 148.294 178.61 148.905 182.79C149.408 186.235 149.003 189.74 147.747 192.961L147.79 192.963C154.743 192.974 161.408 195.745 166.325 200.669C171.251 205.602 174.018 212.293 174.018 219.269C174.018 226.245 171.251 232.936 166.325 237.869C161.399 242.803 154.717 245.575 147.749 245.575H21.0577L21.0434 245.575C15.8401 245.52 10.8377 243.558 6.98286 240.058C3.12808 236.559 0.688394 231.766 0.125084 226.587C-0.438243 221.409 0.913805 216.202 3.92567 211.954C6.57805 208.213 10.3557 205.444 14.6819 204.034C13.7476 202.098 13.2603 199.969 13.2659 197.805C13.2668 193.954 14.7947 190.261 17.5142 187.538C20.2331 184.815 23.9205 183.284 27.7662 183.282C30.8583 183.253 33.86 184.234 36.3267 186.052C37.5771 184.323 39.0985 182.803 40.8349 181.553C42.9998 179.994 45.455 178.886 48.0554 178.294C50.6558 177.702 53.3483 177.638 55.9737 178.106C57.9053 178.451 59.7716 179.078 61.5136 179.965C62.5684 173.904 65.2966 168.242 69.4083 163.633C73.9821 158.505 80.0402 154.934 86.7377 153.418Z",
    fill: "#535353"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62180_28226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6.58594,
    y: 138.805,
    width: 193.641,
    height: 120.569,
    fill: "#D1D9FF"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_62180_28226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 289,
    y: 161,
    width: 143,
    height: 76
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.036 161.95C365.482 160.717 371.176 161.218 376.325 163.381C381.169 165.416 385.302 168.828 388.221 173.184C391.063 171.99 394.192 171.627 397.244 172.149C400.626 172.727 403.738 174.363 406.135 176.821C408.531 179.279 410.089 182.434 410.585 185.832C410.995 188.634 410.665 191.484 409.644 194.103L409.679 194.105C415.333 194.114 420.752 196.367 424.75 200.37C428.756 204.382 431.006 209.822 431.006 215.495C431.006 221.167 428.756 226.607 424.75 230.619C420.744 234.63 415.311 236.884 409.646 236.884H306.63L306.619 236.884C302.388 236.84 298.32 235.244 295.186 232.399C292.051 229.554 290.068 225.656 289.61 221.445C289.151 217.234 290.251 213.001 292.7 209.547C294.857 206.505 297.928 204.253 301.446 203.106C300.686 201.533 300.29 199.801 300.295 198.042C300.295 194.911 301.538 191.908 303.749 189.693C305.96 187.479 308.958 186.235 312.085 186.233C314.599 186.209 317.04 187.007 319.046 188.486C320.063 187.08 321.3 185.844 322.712 184.827C324.472 183.559 326.468 182.658 328.583 182.177C330.697 181.695 332.886 181.643 335.021 182.024C336.592 182.305 338.109 182.815 339.526 183.536C340.384 178.607 342.602 174.004 345.945 170.255C349.664 166.086 354.59 163.182 360.036 161.95Z",
    fill: "#535353"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_62180_28226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.808 174.606C384.993 170.05 380.829 166.487 375.895 164.414C370.962 162.342 365.505 161.862 360.287 163.043C355.068 164.224 350.348 167.007 346.784 171.002C343.22 174.998 340.99 180.008 340.404 185.334C338.712 184.233 336.816 183.483 334.828 183.128C332.841 182.773 330.803 182.822 328.835 183.27C326.866 183.718 325.008 184.557 323.369 185.737C321.73 186.917 320.344 188.415 319.294 190.141C317.338 188.324 314.761 187.327 312.094 187.354C309.263 187.354 306.547 188.481 304.544 190.486C302.542 192.491 301.417 195.211 301.417 198.047C301.412 200.046 301.979 202.004 303.052 203.689L303.156 203.794C299.301 204.687 295.907 206.965 293.616 210.196C291.325 213.427 290.297 217.387 290.725 221.327C291.154 225.266 293.01 228.911 295.941 231.573C298.873 234.234 302.677 235.727 306.634 235.768H409.649C415.018 235.768 420.166 233.632 423.962 229.831C427.758 226.029 429.891 220.873 429.891 215.497C429.891 210.121 427.758 204.965 423.962 201.163C420.166 197.361 415.018 195.226 409.649 195.226C409.07 195.191 408.489 195.191 407.91 195.226C409.394 192.393 409.944 189.162 409.482 185.996C409.02 182.831 407.569 179.893 405.337 177.604C403.106 175.315 400.208 173.792 397.059 173.254C393.91 172.715 390.672 173.189 387.808 174.606ZM387.808 174.606C387.407 175.279 378.946 179.862 383.177 192.201",
    stroke: "#535353",
    strokeWidth: 1.98134,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.148,
    y: 150.07,
    width: 157.453,
    height: 98.0376,
    fill: "#D1D9FF"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 227.633,
    y: 199.09,
    width: 11.9229,
    height: 28.5909,
    fill: "#7E828B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 191.883,
    y: 224.852,
    width: 83.4149,
    height: 5.65573,
    rx: 2.82786,
    fill: "#7E828B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_62180_28226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 84,
    width: 229,
    height: 127
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 121.09,
    y: 86.0586,
    width: 225.003,
    height: 123.448,
    rx: 18.938,
    fill: "#F5821E",
    stroke: "#535353",
    strokeWidth: 2.36725,
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_62180_28226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.09 103.346C121.09 93.7984 128.83 86.0586 138.377 86.0586H328.806C338.353 86.0586 346.093 93.7984 346.093 103.346V192.219C346.093 201.767 338.353 209.507 328.806 209.507H138.377C128.83 209.507 121.09 201.767 121.09 192.219V103.346Z",
    fill: "#EAEEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.973,
    y: 195.25,
    width: 265.238,
    height: 14.2595,
    fill: "#7E828B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.591,
    cy: 202.045,
    r: 2.54456,
    fill: "#140838"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.256,
    cy: 202.045,
    r: 1.20918,
    fill: "#140838"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.58,
    cy: 202.045,
    r: 1.20918,
    fill: "#140838"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.928,
    cy: 202.045,
    r: 1.20918,
    fill: "#140838"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.6,
    cy: 202.045,
    r: 1.20918,
    fill: "#140838"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190 130C201.788 132.903 208.379 133.03 220 130V133.813C207.903 138.225 203.79 137.896 190 133.813V130Z",
    fill: "#322F35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251 130C262.788 132.903 269.379 133.03 281 130V133.813C268.903 138.225 264.79 137.896 251 133.813V130Z",
    fill: "#322F35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.974 63.7011L246.714 51.5681L247.157 47.6059L225.518 45.1894L224.896 50.7641L236.494 52.0594L222.811 64.1988L222.369 68.161L245.161 70.7063L245.784 65.1316L232.974 63.7011Z",
    fill: "#DAE1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M277.728 46.5802L294.143 20.2933L292.949 13.6593L256.72 20.1777L258.399 29.5116L277.818 26.0177L261.5 52.2873L262.693 58.9212L300.855 52.0552L299.175 42.7213L277.728 46.5802Z",
    fill: "#DAE1FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M344.813 43.7923L378.898 20.3808L380.973 11.6296L333.181 0.302067L330.262 12.6149L355.879 18.6864L321.921 42.1281L319.847 50.8793L370.188 62.8109L373.106 50.4982L344.813 43.7923Z",
    fill: "#DAE1FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 164.5,
    r: 5.5,
    fill: "#322F35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoJobs);
export default __webpack_public_path__ + "static/media/no-jobs.9c78d73b26a253cf41d263c2c8407d9a.svg";
export { ForwardRef as ReactComponent };